import BillingGroups from '../components/templates';

export const BillingGroupsContainer = () => {
  return <BillingGroups />;
};
